<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        :style="{ float: 'right' }"
        @onSearch="onSearch"
        @onStartTime="onStartTime"
        @onEndTime="onEndTime"
        @onChangeStatus="onChangeStatus"
      />
    </div>
    <div class="global-table-container">
      <a-button
        style="margin-bottom:10px;"
        type="danger"
        @click="onDeleteAll"
      >
        删除
      </a-button>
      <span
        v-show="isShowError"
        class="errorMsg"
      >请至少选择一项</span>
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        :row-selection="{
          selectedRowKeys,
          onChange:onchangeCheck,
        }"
        @change="changePage"
      >
        <template
          slot="status"
          slot-scope="text, record"
        >
          {{ record.status===2?`${record.status_name}(${record.data.reason})`:record.status_name }}
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            v-if="record.status===0"
            href="javascript:;"
            @click="() => handleCheck(record)"
          >详情</a>
          <a-divider
            v-if="record.status===0"
            type="vertical"
          />
          <a
            v-if="record.status===1"
            href="javascript:;"
            @click="() => handleRemit(record)"
          >打款</a>
          <a-divider
            v-if="record.status===1"
            type="vertical"
          />
          <popconfirm-button
            text="删除"
            alert-title="确定删除?"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <check-modal
      ref="formRef"
      :title="title"
      :visible="visible"
      :disabled="disabled"
      :data="modalData"
      :form-data="formData"
      :btn-is-loading="btnIsLoading"
      @changeRadio="changeRadio"
      @onCancel="onCancel"
      @handleSubmit="handleSubmit"
    />
  </div>
</template>
<script>
import {columns, formData1, formData2, formData3} from './data/index';
import TableSearch from './components/search.vue';
import checkModal from './modal/index.vue';

export default {
  components: {TableSearch, checkModal},
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      visible: false,
      disabled: false,
      title: '',
      modalData: {},
      formData: [],
      id: '',
      selectedRowKeys: [],
      keyword: '',
      status: '-1',
      start_time: '',
      end_time: '',
      isShowError: false,
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading=true;
      let result = await this.$http.post('/userCash/getList', params);
      if (result.data.status===1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            true_name: item.true_name,
            bank_deposit: item.bank_deposit,
            card_number: item.card_number,
            cash_money: item.cash_money,
            status: item.status,
            status_name: item.status_name,
            create_time: this.$Format(item.create_time),
            check_time: item.check_time?this.$Format(item.check_time):'待审核',
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;

      }
    },
    // 时间搜索
    onStartTime(value){
      this.current=1;
      this.start_time=this.$Date(value);
      this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status, keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});

    },
    onEndTime(value){
      this.current=1;
      this.end_time=this.$Date(value);
      this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
    },
    // 状态搜索
    onChangeStatus(val){
      this.current=1;
      this.status=val;
      this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});

    },
    // 搜索
    onSearch(value) {
      this.current=1;
      this.keyword=value;
      this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status, keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
    },

    async onDelete(record){
      let result = await this.$http.post('/userCash/del', {id: record.id});
      if (result.data.status===1) {
        this.getTableData({page: this.current, pageSize: this.pageSize,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
      }
    },
    async onDeleteAll(){
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      let result = await this.$http.post('/userCash/delMore', {ids: this.selectedRowKeys.join()});
      if (result.data.status===1) {
        this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
      }
    },
    // 打款
    handleRemit(record){
      this.visible=true;
      this.title='打款凭证';
      this.modalData=record;
      this.id=record.id;
      this.formData=formData3;
      this.$nextTick(()=>{
        this.$refs.formRef.$refs.basicForm.form.resetFields();
      });
    },
    // 详情
    handleCheck(record){
      this.visible=true;
      this.title='信息审核';
      this.modalData=record;
      this.id=record.id;
      this.formData=formData1;
      this.$nextTick(()=>{
        this.$refs.formRef.$refs.basicForm.form.resetFields();
      });
    },

    changeRadio(e){
      if(e.target.value===1){
        this.formData=formData1;
      }else{
        this.formData=formData2;

      }

    },
    // 确定审核、打款
    handleSubmit(){
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            console.log(values);
            this.btnIsLoading = true;
            let url=values.status?'/userCash/checkCash':'/userCash/makeMoneySave';
            let data=values.status?values:{img_id: values.img_id[0].uid};
            let result = await this.$http.post(url, {
              id: this.id,
              ...data,
            });
            this.btnIsLoading = false;
            if (result.data.status === 1) {
              this.visible = false;
              this.$message.success('操作成功！');
              this.$refs.formRef.$refs.basicForm.form.resetFields();
              this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});
            }
          }
        }
      );
    },
    // 取消审核、打款
    onCancel(){
      this.visible=false;
    },
    // check表格
    onchangeCheck(selectedRowKeys, selectedRows){
      this.selectedRowKeys = selectedRowKeys;
      this.isShowError=false;
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({page: this.current, pageSize: this.pageSize, status: this.status,  keyword: this.keyword, start_time: this.start_time, end_time: this.end_time});

    },
  },
};
</script>
<style lang="scss" scoped>
.errorMsg{
      color: red;
      font-size: 16px;
      margin-left: 10px;
    }
</style>
